import { Component } from "react";
import Loader from "../shared/Loader";

export default class RedirectChangelog extends Component {
  componentDidMount() {
    window.location.assign("https://release-notes.replicated.com/");
  }

  render() {
    return (
      <div className="min-h-full min-w-full flex flex-col flex-1 relative">
        <div className="flex flex-col flex-auto overflow-hidden justify-center items-center">
          <Loader size="70" />
        </div>
      </div>
    );
  }
}
